import { Observable } from '@reactivex/rxjs';
import shallowEqual from 'react-recompose/shallowEqual';
import mapPropsStream from 'react-recompose/mapPropsStream';

function reload() {
    document.location.reload();
}

// latencyThreshold = show "herding stray GPUs" message
// latencyThreshold + refreshThreshold = show "something went wrong" message
export function TrackInitProgress(latencyThreshold = 22000, refreshThreshold = 38000) {
    return mapPropsStream((propsStream) =>
        propsStream.publish((propsStream) =>
            propsStream.timeout(latencyThreshold)
                .catch(updateWithLatencyMessage(propsStream, refreshThreshold))
        )
        .scan((prev, curr) => ({ ...prev, ...curr }), {})
        .distinctUntilChanged(shallowEqual)
    );
}

function updateWithLatencyMessage(propsStream, refreshThreshold) {
    return () => propsStream
        .timeout(refreshThreshold)
        .catch(updateWithRefreshMessage)
        .startWith({ progress: 100, status: 'default', message: `Herding stray GPUs` });
}

function updateWithRefreshMessage() {
    return Observable.of({
        reload,
        status: 'danger', progress: 100,
        message: `Timeout: Click here to reconnect.`
    });
}
